import { ReactNode } from "react";
import { useRouter } from "easy-page-router/react";
import { ThemeDiv } from "./Theme";
import { useLang } from "../services/lang";
import { Theme } from "../../types";

export function Page({ fixed, theme, children }: { theme?: Theme, fixed?: ReactNode, children: ReactNode }) {
    const { path } = useRouter();
    const { dict } = useLang();

    let sectionClass = "";
    if (path.length > 0) {
        if (path[0] === dict.urlCountdown || path[0] === dict.urlTimer) {
            sectionClass = "section-countdown";
        } else if (path[0] === dict.urlPoll) {
            sectionClass = "section-poll";
        } else if (path[0] === dict.urlWho) {
            sectionClass = "section-who";
        } else if (path[0] === dict.urlWhen) {
            sectionClass = "section-when";
        } else if (path[0] === dict.urlTeam) {
            sectionClass = "section-team";
        }
    }

    return <ThemeDiv theme={theme} className={`page-content ${sectionClass}`}>
        {fixed}
        <main>
            {children}
        </main>
    </ThemeDiv>;
}
